<template>
  <div>
    <channel-detail-field class="mb-3">
      <div slot="label">Sender ID:</div>
      <div slot="value">{{ channel.viber_business_messages.sender_id }}</div>
    </channel-detail-field>
    <channel-detail-field class="mb-3">
      <div slot="label">Approved:</div>
      <div slot="value" :class="{'text-success': channel.viber_business_messages.approved}">{{
        channel.viber_business_messages.approved ? 'Yes' : 'No' }}
      </div>
    </channel-detail-field>

    <channel-detail-field v-if="!editMode" class="mb-3">
      <div slot="label">
        Default Message TTL:
        <span id="uri_info" v-b-popover:uri_info.html.hover.right="ttlPopoverText">
          <icon name="info-circle"></icon>
        </span>
      </div>
      <div slot="value">{{ channel.viber_business_messages.default_message_ttl }}</div>
    </channel-detail-field>
    <div v-else class="row form-group">
      <label for="default-message-ttl" class="col-form-label col-4 col-xl-3 text-muted">
        Default Message TTL:
        <span id="uri_info_edit" v-b-popover:uri_info_edit.html.hover.right="ttlPopoverText">
          <icon name="info-circle"></icon>
        </span>
      </label>
      <div class="col-8 col-xl-9">
        <input type="text"
               id="default-message-ttl"
               class="form-control"
               :class="{'is-invalid': defaultMessageTtlError}"
               v-model="editableData.viber_business_messages.default_message_ttl">
        <div v-if="defaultMessageTtlError" class="invalid-feedback">
          {{ defaultMessageTtlError.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ChannelDetailField from '@/components/administration/common/Field'
  import 'vue-awesome/icons/info-circle'
  import 'vue-awesome/icons/exclamation-triangle'
  import find from 'ramda/src/find'
  import propEq from 'ramda/src/propEq'

  const ttlPopoverText = 'Default time span Viber tries to deliver sent message to the user. In ' +
    '<a href="https://en.wikipedia.org/wiki/ISO_8601" target="_blank">ISO 8601 duration format</a>.'

  const approvalWarningText = 'This channel is not approved yet. You won\'t be able to send messages in this mode. If you have questions,\n' +
    '      please email us at <a href="mailto:support@amio.io">support@amio.io</a>.'

  export default {
    components: {
      ChannelDetailField
    },

    store: {
      channel: 'administration.channelDetail.channel',
      editableData: 'administration.channelDetail.channelEdit.editableData'
    },

    props: [
      'editMode',
      'errors'
    ],

    data() {
      return {
        ttlPopoverText,
        approvalWarningText,
        errorMessages: {}
      }
    },

    computed: {
      defaultMessageTtlError() {
        const findTtlError = find(propEq('field', 'viber_business_messages.default_message_ttl'))
        return findTtlError(this.errors)
      },

      showApprovalWarning() {
        return this.checkApproval()
      }
    },

    watch: {
      editMode: function () {
        if (this.editMode) {
          this.prepareStore()
        } else {
          this.cleanUpStore()
        }
      },
      showApprovalWarning: function (val) {
        this.setAlert(val)
      }
    },

    methods: {
      prepareStore() {
        // load data to store
        this.editableData = {
          viber_business_messages: {
            default_message_ttl: this.channel.viber_business_messages.default_message_ttl
          }
        }
      },

      cleanUpStore() {
        this.editableData = {}
      },

      checkApproval() {
        return !(this.channel.viber_business_messages.approved ||
          this.channel.mode === 'test' ||
          this.editMode)
      },

      setAlert(show) {
        const alertEvent = this.$enums.alerts.events.channelInfo

        if (show) {
          const alertType = this.$enums.alerts.types.warning
          this.$emit(alertEvent, true, alertType, this.approvalWarningText)
        } else {
          this.$emit(alertEvent, false)
        }
      }
    },

    mounted() {
      this.setAlert(this.checkApproval())

      const docLink = 'https://docs.amio.io/v1.0/reference#viber-business-messages-text'
      const sandboxPopoverText = `<b>Sandbox</b> - your <a href="${docLink}" target="_blank">Send Message</a>
        requests will be sent using common Amio Sender ID. Messages sent are not charged but number of messages sent is limited.<br/><br/>`
      const sandboxMode = {sandbox: 'Sandbox'}

      this.$emit(this.$enums.alerts.events.updateModeView, docLink, sandboxPopoverText, sandboxMode)
    },

    destroyed() {
      this.setAlert(false)
      this.cleanUpStore()
    }
  }
</script>
